module.exports = __webpack_public_path__ + "img/mail_box_text_box_opened.35525892.png";